import { gql, TypedDocumentNode } from '@apollo/client'
import {
  WebsiteBlog,
  WebsiteBlogFindRequest,
  WebsiteBlogPageableResponse,
  WebsiteBlogInput
} from '../type/website-blog'

export const FindWebsiteBlogs: TypedDocumentNode<
  { websiteBlogsFind: WebsiteBlogPageableResponse },
  { request?: WebsiteBlogFindRequest }
> = gql`
  query FindWebsiteBlogs($request: WebsiteBlogFindRequest) {
    websiteBlogsFind(request: $request) {
      count
      data {
        id        
        name
        type
        url
      }
    }
  }
`

export const FindWebsiteBlogById: TypedDocumentNode<
  { websiteBlogsFind: WebsiteBlogPageableResponse },
  { request?: WebsiteBlogFindRequest }
> = gql`
  query FindWebsiteBlogs($request: WebsiteBlogFindRequest) {
    websiteBlogsFind(request: $request) {
      data {
        id        
        name
        type
        url
        metaTitle
        metaDescription
        content
      }
    }
  }
`

export const RenderContent: TypedDocumentNode<
  { websiteBlogRenderContent: string },
  {
    input: {
      content: any,
    }
  }
> = gql`
  query RenderContent($input: WebsiteBlogRenderContentInput!) {
    websiteBlogRenderContent(input: $input)
  }
`

export const RenderBlog: TypedDocumentNode<
  { websiteBlogRenderBlog: string },
  { id: number }
> = gql`
  query RenderBlog($id: Int!) {
    websiteBlogRenderBlog(id: $id)
  }
`

// Mutation to create a new blog
export const CreateWebsiteBlog: TypedDocumentNode<
  { websiteBlogCreate: WebsiteBlog },
  { input: WebsiteBlogInput }
> = gql`
  mutation CreateWebsiteBlog($input: WebsiteBlogInput!) {
    websiteBlogCreate(input: $input)
  }
`

// Mutation to update a blog
export const UpdateWebsiteBlog: TypedDocumentNode<
  { websiteBlogUpdate: WebsiteBlog },
  { 
    id: number
    input: WebsiteBlogInput 
  }
> = gql`
  mutation UpdateWebsiteBlog($id: Int!, $input: WebsiteBlogInput!) {
    websiteBlogUpdate(id: $id, input: $input)
  }
`

// Mutation to delete a blog
export const DeleteWebsiteBlog: TypedDocumentNode<
  { websiteBlogDelete: boolean },
  { id: number }
> = gql`
  mutation DeleteWebsiteBlog($id: Int!) {
    websiteBlogDelete(id: $id)
  }
`

